import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { sessao } from './api';
import Layout from './Layout.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Ordens from './pages/Ordens.jsx';
import OrdemDetalhe from './pages/OrdemDetalhe.jsx';
import NovaOS from './pages/NovaOS.jsx';
import Expedicao from './pages/Expedicao.jsx';
import Lojas from './pages/Lojas.jsx';
import Usuarios from './pages/Usuarios.jsx';
import Formas from './pages/Formas.jsx';
import Relatorios from './pages/Relatorios.jsx';
import Fornecedores from './pages/Fornecedores.jsx';

function Protegida({ children, quando = true }) {
  const u = sessao.usuario;
  if (!u) return <Navigate to="/login" replace />;
  if (!quando) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function Inicio() {
  const u = sessao.usuario;
  if (!u) return <Navigate to="/login" replace />;
  if (u.perfil === 'admin') return <Navigate to="/dashboard" replace />;
  if (u.perfil === 'expedicao') return <Navigate to="/expedicao" replace />;
  return <Navigate to="/nova-os" replace />;
}

export default function App() {
  const u = sessao.usuario;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Inicio />} />
        <Route path="/dashboard" element={<Protegida quando={u?.perfil === 'admin' || u?.perms?.ver_relatorios}><Dashboard /></Protegida>} />
        <Route path="/ordens" element={<Protegida><Ordens /></Protegida>} />
        <Route path="/ordens/:id" element={<Protegida><OrdemDetalhe /></Protegida>} />
        <Route path="/nova-os" element={<Protegida quando={u?.perfil === 'admin' || u?.perms?.criar_os}><NovaOS /></Protegida>} />
        <Route path="/expedicao" element={<Protegida quando={u?.perfil === 'admin' || u?.perms?.alterar_status}><Expedicao /></Protegida>} />
        <Route path="/lojas" element={<Protegida quando={u?.perfil === 'admin'}><Lojas /></Protegida>} />
        <Route path="/usuarios" element={<Protegida quando={u?.perfil === 'admin' || u?.perms?.gerenciar_usuarios}><Usuarios /></Protegida>} />
        <Route path="/relatorios" element={<Protegida quando={u?.perfil === 'admin' || u?.perms?.ver_relatorios}><Relatorios /></Protegida>} />
        <Route path="/fornecedores" element={<Protegida quando={u?.perfil === 'admin'}><Fornecedores /></Protegida>} />
        <Route path="/formas" element={<Protegida quando={u?.perfil === 'admin'}><Formas /></Protegida>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
